import { removeFalsy } from "helpers/formatter";
import { GroupForListing } from "models/group";
import apiService from "modules/api/apiService";
import { GROUP_CRUD, LOOKUPS_GROUPS_LISTING } from "modules/api/endpoint";
import { TPagination } from "modules/api/type";

export const getGroups = async (
  params: any
): Promise<{
  success: boolean;
  data?: GroupForListing[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_GROUPS_LISTING}${queryParams ? `?${queryParams}` : ""}`
    );

    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const getGroup = async (
  params: any
): Promise<{
  success: boolean;
  data?: any;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${GROUP_CRUD}${queryParams ? `?${queryParams}` : ""}`);

    const modifiedGroupObject = modifyGroupResponse(results.data.payload[0]);

    console.log("modified group object", modifiedGroupObject);

    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const deleteGroup = async (
  params: any
): Promise<{
  success: boolean;
  data?: any;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.del(`${GROUP_CRUD}${queryParams ? `?${queryParams}` : ""}`);

    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

const modifyGroupResponse = (groupObject) => {
  let modifiedGroupObject = {
    exclude_goals: [],
    exclude_health_conditions: {},
    exclude_interests: {},
    include_goals: [],
    include_health_conditions: {},
    include_interests: {},
  };
  [
    "include_interests",
    "exclude_interests",
    "include_health_conditions",
    "include_health_conditions",
  ].forEach((type) => {
    groupObject[type].forEach((relatedObject) => {
      if (typeof modifiedGroupObject[type][relatedObject.category_alias] === "undefined") {
        modifiedGroupObject[type][relatedObject.category_alias] = [];
      }
      modifiedGroupObject[type][relatedObject.category_alias].push(relatedObject.id);
    });
  });
  ["include_goals", "exclude_goals"].forEach((type) => {
    groupObject[type].forEach((relatedObject) => {
      modifiedGroupObject[type].push(relatedObject.id);
    });
  });

  return { ...groupObject, ...modifiedGroupObject };
};
